export function getProductFractionSpecificationString(
  { normCode = null, articleNumber = null, norm_code = null, article_number = null },
  { parenthesis = true } = {}
) {
  const _normCode = normCode ?? norm_code;
  const _articleNumber = articleNumber ?? article_number;


  const normCodeText = _normCode ? `${i18n('norm_code')} ${_normCode}` : '';
  const articleNumberText = _articleNumber && IS_ARTICLE_NUMBER_ENABLED ? `${i18n('article_number')} ${_articleNumber}` : '';

  const specificationText = [articleNumberText, normCodeText].filter(Boolean).join(' / ');

  return parenthesis && specificationText ? `(${specificationText})` : specificationText;
}
